module.exports = __webpack_public_path__ + "img/E.82708271.jpg";